import { istToday, istYearMonth } from './formatIst';

/** Last calendar day of YYYY-MM as YYYY-MM-DD. */
export function lastDayOfMonthYm(yearMonth) {
  const ym = String(yearMonth || '').trim().slice(0, 7);
  const m = ym.match(/^(\d{4})-(\d{2})$/);
  if (!m) return null;
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const last = new Date(y, mo, 0).getDate();
  return `${ym}-${String(last).padStart(2, '0')}`;
}

/** Inclusive { start, end } for a YYYY-MM month. */
export function monthBoundsYm(yearMonth) {
  const ym = String(yearMonth || '').trim().slice(0, 7);
  if (!/^\d{4}-\d{2}$/.test(ym)) return null;
  const end = lastDayOfMonthYm(ym);
  if (!end) return null;
  return { start: `${ym}-01`, end };
}

/** Day numbers 1..N for the month. */
export function daysInMonthYm(yearMonth) {
  const end = lastDayOfMonthYm(yearMonth);
  if (!end) return [];
  const n = parseInt(end.slice(8, 10), 10);
  return Array.from({ length: n }, (_, i) => i + 1);
}

/** YYYY-MM-DD for day number within month. */
export function ymdForDay(yearMonth, dayNum) {
  const ym = String(yearMonth || '').trim().slice(0, 7);
  return `${ym}-${String(dayNum).padStart(2, '0')}`;
}

export function defaultAttendanceMonth() {
  return istYearMonth();
}

/** Cell status for monthly grid. */
export function dayCellStatus(dayEntry, dayYmd, todayYmd) {
  if (!dayEntry) {
    if (dayYmd > todayYmd) return 'future';
    return 'absent';
  }
  if (dayEntry.status === 'active') return 'active';
  return 'present';
}
